import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import Routing from './routing.js';
import { Provider } from 'react-redux'
import store from './store.js';


ReactDOM.render(
  <Provider store = {store}>
    <Routing />
  </Provider>,
  document.getElementById('root'));
registerServiceWorker();
